import Image from "@/components/Atoms/Image";
import styles from "./index.module.scss";

interface Props {
  data: any;
  className?: any;
  position?: string;
}

function parallaxAlignClass(position?: string) {
  return position === "left"
    ? "left-0 translate-x-[-50%]"
    : "right-0 translate-x-[50%]";
}

function aboveParallaxAlignClass(position?: string) {
  return position === "left"
    ? "left-0 lg:translate-x-[-50%]"
    : "right-0 lg:translate-x-[50%]";
}

export function BellowParallaxImage({ data, position }: Props): JSX.Element {
  return (
    <div
      className={`${styles.behind} absolute top-0 bottom-0 m-auto flex items-end ${parallaxAlignClass(
        position
      )}`}
    >
      <Image data={data} />
    </div>
  );
}

export function AboveParallaxImage({
  data,
  className,
  position,
}: Props): JSX.Element {
  return (
    <div
      className={`w-full absolute top-0 bottom-0 m-auto flex items-end ${className} ${styles.styleBg} ${aboveParallaxAlignClass(
        position
      )}`}
    >
      <Image data={data} />
    </div>
  );
}

export function ParallaxImage({
  data,
  className,
  position,
}: Props): JSX.Element {
  return (
    <div
      className={` w-full absolute top-0 bottom-0 m-auto z-[-1] flex items-end ${className} ${styles.styleBg} `}
    >
      <Image data={data} />
    </div>
  );
}

export function CenterParallaxImage({ data }: Props): JSX.Element {
  return (
    <div
      className={`pointer-events-none absolute left-1/2 z-30 flex -translate-x-1/2 items-end max-lg:top-1/2 max-lg:-translate-y-1/2 lg:bottom-0 ${styles.centerParallax}`}
    >
      <Image data={data} />
    </div>
  );
}

export function StyleBackgroundImage({ data, position }: Props): JSX.Element {
  return (
    <div
      className={`  absolute m-auto  bottom-0 top-0  flex  justify-center items-start  w-full ${
        position == "left" ? "left-0 lg:left-[0%]" : "right-[0%]"
      }   z-[0] `}
    >
      <Image className="h-fit" data={data} />
    </div>
  );
}
